import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=40eb51a9"
import script from "@/scripts/gpuHub/invoices/invoices.js?vue&type=script&lang=js&external"
export * from "@/scripts/gpuHub/invoices/invoices.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports